import { InputBase, type InputBaseProps } from '@mui/material';
import type React from 'react';
import styles from '../AdministrationStyles';

interface AdminTextInputProps extends Omit<InputBaseProps, 'className'> {
  label?: string;
  className?: string;
}

export const AdminTextInput = ({
  label,
  className: externalClassName,
  ...rest
}: AdminTextInputProps): React.ReactElement => {
  const classes = styles();

  const className = externalClassName ? `${externalClassName} ${classes.adminTextInput}` : classes.adminTextInput;

  return (
    <div>
      <div className={classes.adminTextInputLabel}>{label}</div>
      <InputBase {...rest} className={className} />
    </div>
  );
};
